'use client'
import React from 'react';
import { Empty } from 'antd';
import { type Blog } from '@/lib/@types/api/blog';
import BlogItemDefault from "@/components/Blogs/BlogItemDefault";
interface BlogListProps {
	blogList: Blog.BlogListItem[];
}

const BlogList: React.FC<BlogListProps> = ({ blogList }) => {
  console.log(blogList,'blogListblogList');
	return (
		blogList.length>0 ?	<div className="list-blog grid grid-cols-3 max-md:grid-cols-1 gap-x-5 gap-y-5">
			{ blogList.map((item) => (
				<BlogItemDefault key={item.blog_slug} news={item}  />
			))}
		</div>:<div className="w-full h-full flex justify-center items-center"> <Empty  /></div>
	);
};

export default BlogList;
